export default __webpack_public_path__ + "static/media/david14.7aa21ed9.jpg";